<template>
    <div class="w-100">
        <div class="row">
            <div class="col-6 text-left">
                <button class="btn btn-outline-danger" @click="$emit('delete')" :disabled="!canWrite">
                    <i class="fa fa-trash-o" /> {{deleteButtonText}}
                </button>
            </div>

            <div class="col-6 text-right">
                <button class="btn btn-danger mr-3" @click="$emit('cancel')">
                    <i class="fas fa-backspace mr-1" /> {{resource('Button_Cancel')}}
                </button>

                <button :class="{ disabled: invalid }" class="btn btn-success" @click="$emit('save')" :disabled="!canWrite">
                    <i class="far fa-save mr-1" /> {{resource('Button_Save')}}
                </button>
            </div>
        </div>
    </div>
</template>

<script>
import permissionsMixin from '@modules/JourneyBuilder/Mixins/journey-permissions';
import resourceMixin from "@core/Util/Mixins/resources";

export default {
    name: "settings-controls",
    mixins: [resourceMixin, permissionsMixin],
    props: {
        invalid: {
            type: Boolean,
            required: false,
            default: false
        },
        deleteButtonText: {
            type: String,
            required: true,
            //default: () => resources('JourneyBuilder_Button_DeleteCheckpoint')
        }
    }
}
</script>
